import _ from 'lodash'
import Vue from "vue";
import { E_AlarmLevel, E_AlarmLevel2, E_AlarmStatus, E_AlarmType, E_DeviceStatus } from "@/api/enums";
import { E_AlarmAttachType, E_AlarmMode, E_DealStatus } from "@/api/moudules/alarm.types";
import { E_AlgorithmTrendStatus, E_ApefStartStatus } from "@/api/moudules/alarmStatistics.types";
import { E_AreaPicStatus, E_CompanyStatus } from "@/api/moudules/company.types";
import { E_BindSensorType, E_CardStatus, E_ConnectType_LoRa, E_DHCPModel, E_DataStatus, E_GateWayModel, E_GatewayDHCPModel, E_GatewayDataFormat, E_GatewayOnLineStatus, E_GatewayStatus, E_GatewayTranslateProtocol, E_GatewayType, E_GatewayUpgradeStatus, E_LoraBandwidth, E_LoraBandwidthInverse, E_LoraLowSpeedOpt, E_OfflineDataStatus, E_RegisterStatus, E_SensorPushStatus, E_SensorRegisterStatus, E_SimNetworkRegisterStatus, E_SimOnlineStatus, E_SimStatus, E_WifiConnectStatus, E_WifiStatus } from "@/api/moudules/gateway.types";
import { E_AuditLogModule, E_AuditRiskLevel, E_BusinessType, E_LoginAccountActivity, E_LoginAccountStatus, E_LoginAuthType, E_LoginStatus, E_LoginType, E_OperatorStatus, E_OperatorType } from "@/api/moudules/monitor.types";
import { E_OnlineOffline } from "@/api/moudules/overview.types";
import { E_KnownRoles, E_MenuStatus, E_MenuType, E_MenuType__Invert, E_PushAppMessage } from "@/api/moudules/system.types";
import { E_ChartTypeString, E_Eigenvalue, E_EigenvalueKind, E_RssiLevel, E_FaultAlysisStatistics, E_Status, E_StatusString, E_StatusString__Invert } from "@/types";
import { E_EquipmentLevel } from "@/api/moudules/equipment.types";
import { E_LaunchState, E_ModelPartial } from "@/api/moudules/model.types";
import { E_CustomThreshold } from "@/api/moudules/threshold.types";
import { E_Sex, E_Sex__Invert } from "@/api/moudules/system";
import { E_CollectMode, E_CollectWork, E_InstallMethod, E_MHFFlag, E_SensorCurrentLegend, E_SensorDirection, E_SensorKlass, E_SensorType, E_StartStatus, hasSensorKlassTrans } from "@/api/moudules/sensor.types";
import { E_WaveTabs } from "@/views/wave/types";
import { E_ChartType } from "@/utils/chart";
import { E_DataSearchTableCol } from "@/view_helper/dataSearch";
import { E_WeeklyReportEquipmentStatus, E_WeeklyReportSeverityLevel, E_WeekReportDealStatus } from '@/api/moudules/weeklyReport.types';
import { E_ErrorCodes } from '@/api/errorCodes';
import { E_Eigenvalue2 } from '@/api/moudules/eigenvalue.types';
import { E_AuthorityRange } from '@/api/moudules/authority.types';
import { E_EmailType } from '@/api/moudules/email.types';
import { E_InspectionStandardCollectMode } from '@/spot_check/api/modules/inspection/inspection_standard.types';
import { E_InspectionPointStatus, E_InspectionPointType } from '@/spot_check/api/modules/inspection/inspection_point.types';
import { E_AppUpdateType, E_AppVersionStatus } from '@/api/moudules/appver.types';
import { E_InspectStatus, E_InspectType, E_InspectionTaskStatus, E_InspectionYesNo, E_LineType } from '@/spot_check/api/modules/inspection/inspection_task.types';
import { E_AuditStatus, E_DangerLevel, E_DangerStatus, E_HandleStatus } from '@/spot_check/api/modules/inspection_danger/inspection_danger.types';
import { E_UpkeepHandleResult, E_UpkeepLevel } from '@/spot_check/api/modules/inspection_upkeep/inspection_upkeep.types';
import { E_FaultEffect, E_RepairLevel } from '@/spot_check/api/modules/inspection_repair/inspection_repair.types';
import { E_UpkeepRepairHandleStatus } from '@/spot_check/api/modules/types';
import { E_AlarmLampEquipmentType } from '@/api/moudules/alarmLamp.types';
import { E_FirewareUpgradeStatus, E_FirmwireDeviceType, E_UpgradeStatus } from '@/api/moudules/firmware.types';
import { E_AlarmLevelString, E_AlarmLevelString__Inverse } from '@/api/moudules/largeScreen.types';
import { E_CarrierReversal, E_CoefType, E_CommunicationProtocolType, E_ConvertProtocolType, E_DataSamplingMode, E_DriveType, E_ProtocolVersion, E_SendWaveStatus, E_SensorDownloadStatus, E_SyncCollectStatus, E_UnbindSensorStatus, E_WaveCompressFlag } from '@/api/moudules/sensorNew.types';
import { E_ChannelType, E_CollectCardCollMode, E_CollectCardCoutingMode, E_CollectCardDirection, E_CollectCardTriggerDirection, E_ConstantCurrentSource, E_SelectChannel } from '@/api/moudules/collectCard.types';
import { E_SensorNetworkingCollType } from '@/api/moudules/sensorNetworking.types';
import { E_FaultStatus, E_UseLearnStatus } from '@/api/moudules/sensorThreshold.types';
import { E_OpenClose1_2, E_Weekdays, E_YesNoNumber } from '@/api/types';
import { E_AppCustoms } from '@/constants/app';
import { E_AiDiagnosisStatus } from '@/api/moudules/ai.types';
import { E_DiagnosticResults, E_FaultType } from '@/api/moudules/fault.types';
import { E_Lang } from './types';
import { E_EquipmentType } from '@/view_helper/model';
import { E_MenuItem } from '@/view_helper/menu';
import { E_WirelessFrequency } from '@/view_helper/gateway';
import { E_ScoreLevelRange } from '@/view_helper/score';
import { E_ScoreAlarmStatus, E_ScoreStatus } from '@/api/moudules/score.types';
import { E_PlatformCustoms } from '@/constants/platform';
import { E_FaultCaseLibraryIsPublic } from '@/api/moudules/faultCaseLibrary.types';
import { E_EquipmentRunStatus } from '@/api/moudules/equipmentRunThreshold.types';
import { E_EquipmentOrderBy } from '@/types/order';
import { E_MapType, E_MapTypeStr, E_ModelFaultType, E_ModelFaultType_Invert, E_ModelFaultTypeKind } from '@/api/moudules/diagnosis.types';
import { E_OrderByColumn } from '@/api/moudules/onlineDetection.types';
import { E_IsInspect, E_RepeatFlag, E_TaskCycleType } from '@/spot_check/api/modules/inspection/inspection_taskPlan.types';
import { E_FaultTagGraphCategory, E_FaultTagType } from '@/api/moudules/faultTagLibrary.types';
import { E_IndustryType } from '@/api/moudules/customerManager.types';

export class UnitTrans {
    constructor(public vm: Vue) {
    }
    $t(key: string, ...args) {
        return this.vm.$t(key, ...args) as string
    }
    toSecond = (value: number) => {
        return this.$t('common.secondsTemplate', {
            value
        });
    }
}

export class EnumTrans {
    constructor(public vm: Vue) {
    }
    $t(key: string) {
        return this.vm.$t(key) as string
    }
    OnlineOffline = (value: E_OnlineOffline) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_OnlineOffline[value]
        return this.$t('enum.E_OnlineOffline.' + key)
    }
    AlarmType = (value: E_AlarmType) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_AlarmType[value]
        return this.$t('enum.E_AlarmType.' + key)
    }
    AlarmType__Filter = (value: E_AlarmType) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_AlarmType[value]
        return this.$t('enum.E_AlarmType__Filter.' + key)
    }
    AlarmLevel = (value: E_AlarmLevel) => {
        const key = E_AlarmLevel[value]
        if (_.isNil(key)) {
            return
        }
        return this.$t('enum.E_AlarmLevel.' + key)
    }
    AlarmLevel__long = (value: E_AlarmLevel) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_AlarmLevel[value]
        return this.$t('enum.E_AlarmLevel__long.' + key)
    }
    AlarmLevel2 = (value: E_AlarmLevel2) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_AlarmLevel2[value]
        return this.$t('enum.E_AlarmLevel2.' + key)
    }
    AlarmMode = (value: E_AlarmMode) => {
        const knownValue = [
            E_AlarmMode.Eigenvalue, E_AlarmMode.Wave,
        ]
        if (!knownValue.includes(value)) {
            return value
        }
        const key = E_AlarmMode[value]
        return this.$t('enum.E_AlarmMode.' + key)
    }
    AlgorithmTrendStatus = (value: E_AlgorithmTrendStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_AlgorithmTrendStatus[value]
        return this.$t('enum.E_AlgorithmTrendStatus.' + key)
    }
    ApefStartStatus = (value: E_ApefStartStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_ApefStartStatus[value]
        return this.$t('enum.E_ApefStartStatus.' + key)
    }
    DealStatus = (value: E_DealStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_DealStatus[value]
        return this.$t('enum.E_DealStatus.' + key)
    }
    DealStatusBi = (value: E_DealStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_DealStatus[value]
        return this.$t('enum.E_DealStatus_Bi.' + key)
    }
    GatewayStatus = (value: E_GatewayStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_GatewayStatus[value]
        return this.$t('enum.E_GatewayStatus.' + key)
    }
    CompanyStatus = (value: E_CompanyStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_CompanyStatus[value]
        return this.$t('enum.E_CompanyStatus.' + key)
    }
    IndustryType = (value: E_IndustryType) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_IndustryType[value]
        return this.$t('enum.E_IndustryType.' + key)
    }
    MenuStatus = (value: E_MenuStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_MenuStatus[value]
        return this.$t('enum.E_MenuStatus.' + key)
    }
    /**
     * 设备状态     
     */
    DeviceStatus = (value: E_DeviceStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_DeviceStatus[value]
        return this.$t('enum.E_DeviceStatus.' + key)
    }

    Status = (value: E_Status) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_Status[value]
        return this.$t('enum.E_Status.' + key)
    }

    StatusString = (value: E_StatusString) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_StatusString__Invert[value]
        return this.$t('enum.E_StatusString.' + key)
    }

    /**
     * 设备等级     
     */
    EquipmentLevel = (value: E_EquipmentLevel) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_EquipmentLevel[value]
        return this.$t('enum.E_EquipmentLevel.' + key)
    }

    /**
     * 模型部件
     */
    ModelPartial = (value: E_ModelPartial) => {
        const key = E_ModelPartial[value]
        return this.$t('enum.E_ModelPartial.' + key)
    }

    /**
     * 网关类型
     */
    GatewayType = (value: E_GatewayType) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_GatewayType[value]
        return this.$t('enum.E_GatewayType.' + key)
    }
    /**
     * 绑定传感器类型
     */
    BindSensorType = (value: E_BindSensorType) => {
        const key = E_BindSensorType[value]
        return this.$t('enum.E_BindSensorType.' + key)
    }

    ConnectType_LoRa = (value: E_ConnectType_LoRa) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_ConnectType_LoRa[value]
        return this.$t('enum.E_ConnectType_LoRa.' + key)
    }

    LaunchState = (value: E_LaunchState) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_LaunchState[value]
        return this.$t('enum.E_LaunchState.' + key)
    }

    CustomThreshold = (value: E_CustomThreshold) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_CustomThreshold[value]
        return this.$t('enum.E_CustomThreshold.' + key)
    }

    Sex = (value: E_Sex) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_Sex__Invert[value]
        return this.$t('enum.E_Sex.' + key)
    }

    MHFFlag = (value: E_MHFFlag) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_MHFFlag[value]
        return this.$t('enum.E_MHFFlag.' + key)
    }
    MHFFlag_2 = (value: E_MHFFlag) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_MHFFlag[value]
        return this.$t('enum.E_MHFFlag_2.' + key)
    }

    CollectWork = (value: E_CollectWork) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_CollectWork[value]
        return this.$t('enum.E_CollectWork.' + key)
    }

    CollectMode = (value: E_CollectMode) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_CollectMode[value]
        return this.$t('enum.E_CollectMode.' + key)
    }

    /**
     * 操作人类别     
     */
    OperatorType = (value: E_OperatorType) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_OperatorType[value]
        return this.$t('enum.E_OperatorType.' + key)
    }

    OperatorStatus = (value: E_OperatorStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_OperatorStatus[value]
        return this.$t('enum.E_OperatorStatus.' + key)
    }

    LoginType = (value: E_LoginType) => {
        if (_.isNil(value)) {
            return
        }
        return this.$t('enum.E_LoginType.' + value)
    }

    LoginStatus = (value: E_LoginStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_LoginStatus[value]
        return this.$t('enum.E_LoginStatus.' + key)
    }

    LoginAccountActivity = (value: E_LoginAccountActivity) => {
        if (_.isNil(value)) {
            return
        }
        const key = _.findKey(E_LoginAccountActivity, item => item === value)
        return this.$t('enum.E_LoginAccountActivity.' + key)
    }

    LoginAccountStatus = (value: E_LoginAccountStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = _.findKey(E_LoginAccountStatus, item => item === value)
        return this.$t('enum.E_LoginAccountStatus.' + key)
    }

    LoginAuthType = (value: E_LoginAuthType) => {
        if (_.isNil(value)) {
            return
        }
        const key = _.findKey(E_LoginAuthType, item => item === value)
        return this.$t('enum.E_LoginAuthType.' + key)
    }

    AuditRiskLevel = (value: E_AuditRiskLevel) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_AuditRiskLevel[value]
        return this.$t('enum.E_AuditRiskLevel.' + key)
    }

    AuditLogModule = (value: E_AuditLogModule) => {
        if (_.isNil(value)) {
            return
        }
        const key = _.findKey(E_AuditLogModule, item => item === value)
        return this.$t('enum.E_AuditLogModule.' + key)
    }

    /**
     * 业务操作类型     
     */
    BusinessType = (value: E_BusinessType) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_BusinessType[value]
        return this.$t('enum.E_BusinessType.' + key)
    }

    /**
     * 菜单类型
     */
    MenuType = (value: E_MenuType) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_MenuType__Invert[value]
        return this.$t('enum.E_MenuType.' + key)
    }

    /**
     * 图谱
     */
    WaveTabs = (value: E_WaveTabs) => {
        const key = E_WaveTabs[value]
        return this.$t('enum.E_WaveTabs.' + key)
    }

    /**
     * 图表类型
     */
    ChartType = (value: E_ChartType) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_ChartType[value]
        return this.$t('enum.E_ChartType.' + key)
    }

    /**
     * 图例类型     
     */
    ChartTypeString = (value: E_ChartTypeString) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_ChartTypeString[value]
        return this.$t('enum.E_ChartTypeString.' + key)
    }

    /**
     * 
     */
    DataSearchTableCol = (value: E_DataSearchTableCol) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_DataSearchTableCol[value]
        return this.$t('enum.E_DataSearchTableCol.' + key)
    }

    SensorDirection = (value: E_SensorDirection) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_SensorDirection[value]
        return this.$t('enum.E_SensorDirection.' + key)
    }

    Eigenvalue = (value: E_Eigenvalue) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_Eigenvalue[value]
        return this.$t('enum.E_Eigenvalue.' + key)
    }

    /**
     * 安装方式     
     */
    InstallMethod = (value: E_InstallMethod) => {
        if (_.isNil(value)) {
            return
        }
        const key = value
        return this.$t('enum.E_InstallMethod.' + key)
    }
    /**
     * 诊断错误
     */
    FaultAlysisStatistics = (value: E_FaultAlysisStatistics) => {
        if (_.isNil(value)) {
            return
        }
        const key = value
        return this.$t('enum.E_FaultAlysisStatistics.' + key)
    }
    /**
     * 数据上云状态
     */
    DataStatus = (value?: E_DataStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_DataStatus[value]
        return this.$t('enum.E_DataStatus.' + key)
    }
    // 周报
    WeeklyReportEquipmentStatus = (value: E_WeeklyReportEquipmentStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_WeeklyReportEquipmentStatus[value]
        return this.$t('enum.E_WeeklyReportEquipmentStatus.' + key)
    }
    WeeklyReportSeverityLevel = (value: E_WeeklyReportSeverityLevel) => {
        if (_.isNil(value)) {
            return value
        }
        const key = E_WeeklyReportSeverityLevel[value]
        return this.$t('enum.E_WeeklyReportSeverityLevel.' + key)
    }

    //错误码
    ErrorCodes = (value: E_ErrorCodes) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_ErrorCodes[value]
        return this.$t('enum.E_ErrorCodes.' + key)
    }

    Eigenvalue2 = (value: E_Eigenvalue2) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_Eigenvalue2[value]
        return this.$t('enum.E_Eigenvalue2.' + key)
    }
    AuthorityRange = (value: E_AuthorityRange) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_AuthorityRange[value]
        return this.$t('enum.E_AuthorityRange.' + key)
    }
    EmailType = (value: E_EmailType) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_EmailType[value]
        return this.$t('enum.E_EmailType.' + key)
    }
    InspectionStandardCollectMode = (value: E_InspectionStandardCollectMode) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_InspectionStandardCollectMode[value]
        return this.$t('enum.E_InspectionStandardCollectMode.' + key)
    }
    InspectionPointType = (value: E_InspectionPointType) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_InspectionPointType[value]
        return this.$t('enum.E_InspectionPointType.' + key)
    }
    InspectionPointStatus = (value: E_InspectionPointStatus) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_InspectionPointStatus[value]
        return this.$t('enum.E_InspectionPointStatus.' + key)
    }
    AppUpdateType = (value: E_AppUpdateType) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_AppUpdateType[value]
        return this.$t('enum.E_AppUpdateType.' + key)
    }
    AppVersionStatus = (value: E_AppVersionStatus) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_AppVersionStatus[value]
        return this.$t('enum.E_AppVersionStatus.' + key)
    }
    AreaPicStatus = (value: E_AreaPicStatus) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_AreaPicStatus[value]
        return this.$t('enum.E_AreaPicStatus.' + key)
    }
    InspectionYesNo = (value: E_InspectionYesNo) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_InspectionYesNo[value]
        return this.$t('enum.E_InspectionYesNo.' + key)
    }
    InspectType = (value: E_InspectType) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_InspectType[value]
        return this.$t('enum.E_InspectType.' + key)
    }
    LineType = (value: E_LineType) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_LineType[value]
        return this.$t('enum.E_LineType.' + key)
    }
    InspectionTaskStatus = (value: E_InspectionTaskStatus) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_InspectionTaskStatus[value]
        return this.$t('enum.E_InspectionTaskStatus.' + key)
    }
    /**
     * 巡检状态     
     */
    InspectStatus = (value: E_InspectStatus) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_InspectStatus[value]
        return this.$t('enum.E_InspectStatus.' + key)
    }

    /**
     * 隐患单状态     
     */
    DangerStatus = (value: E_DangerStatus) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_DangerStatus[value]
        return this.$t('enum.E_DangerStatus.' + key)
    }

    /**
     *  隐患等级 
     */
    DangerLevel = (value: E_DangerLevel) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_DangerLevel[value]
        return this.$t('enum.E_DangerLevel.' + key)
    }

    /**
     *  审核状态
     */
    AuditStatus = (value: E_AuditStatus) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_AuditStatus[value]
        return this.$t('enum.E_AuditStatus.' + key)
    }

    /**
     *  审核状态
     */
    AuditStatus2 = (value: E_AuditStatus) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_AuditStatus[value]
        return this.$t('enum.E_AuditStatus2.' + key)
    }



    HandleStatus = (value: E_HandleStatus) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_HandleStatus[value]
        return this.$t('enum.E_HandleStatus.' + key)
    }

    UpkeepLevel = (value: E_UpkeepLevel) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_UpkeepLevel[value]
        return this.$t('enum.E_UpkeepLevel.' + key)
    }

    UpkeepRepairHandleStatus = (value: E_UpkeepRepairHandleStatus) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_UpkeepRepairHandleStatus[value]
        return this.$t('enum.E_UpkeepRepairHandleStatus.' + key)
    }

    UpkeepHandleResult = (value: E_UpkeepHandleResult) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_UpkeepHandleResult[value]
        return this.$t('enum.E_UpkeepHandleResult.' + key)
    }

    RepairLevel = (value: E_RepairLevel) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_RepairLevel[value]
        return this.$t('enum.E_RepairLevel.' + key)
    }

    FaultEffect = (value: E_FaultEffect) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_FaultEffect[value]
        return this.$t('enum.E_FaultEffect.' + key)
    }
    AlarmLampEquipmentType = (value: E_AlarmLampEquipmentType) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_AlarmLampEquipmentType[value]
        return this.$t('enum.E_AlarmLampEquipmentType.' + key)
    }
    StartStatus = (value: E_StartStatus) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_StartStatus[value]
        return this.$t('enum.E_StartStatus.' + key)
    }
    StartStatus__2 = (value: E_StartStatus) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_StartStatus[value]
        return this.$t('enum.E_StartStatus__2.' + key)
    }
    UpgradeStatus = (value: E_UpgradeStatus) => {
        if (_.isNil(value)) {
            return ''
        }
        const key = E_UpgradeStatus[value]
        return this.$t('enum.E_UpgradeStatus.' + key)
    }
    SensorType = (value: E_SensorType) => {
        if (_.isNil(value)) {
            return undefined
        }
        const key = E_SensorType[value]
        return this.$t('enum.E_SensorType.' + key)
    }
    AlarmLevelString = (value: E_AlarmLevelString) => {
        if (_.isNil(value)) {
            return undefined
        }
        const key = E_AlarmLevelString__Inverse[value]
        return this.$t('enum.E_AlarmLevelString.' + key)
    }
    DriveType = (value: E_DriveType) => {
        if (_.isNil(value)) {
            return undefined
        }
        const key = E_DriveType[value]
        return this.$t('enum.E_DriveType.' + key)
    }

    CollectCardCoutingMode = (value: E_CollectCardCoutingMode) => {
        if (_.isNil(value)) {
            return undefined
        }
        const key = E_CollectCardCoutingMode[value]
        return this.$t('enum.E_CollectCardCoutingMode.' + key)
    }
    CollectCardDirection = (value: E_CollectCardDirection) => {
        if (_.isNil(value)) {
            return undefined
        }
        const key = E_CollectCardDirection[value]
        return this.$t('enum.E_CollectCardDirection.' + key)
    }
    SelectChannel = (value: E_SelectChannel) => {
        if (_.isNil(value)) {
            return undefined
        }
        const key = E_SelectChannel[value]
        return this.$t('enum.E_SelectChannel.' + key)
    }
    CollectCardCollMode = (value: E_CollectCardCollMode) => {
        if (_.isNil(value)) {
            return undefined
        }
        const key = E_CollectCardCollMode[value]
        return this.$t('enum.E_CollectCardCollMode.' + key)
    }
    CollectCardTriggerDirection = (value: E_CollectCardTriggerDirection) => {
        if (_.isNil(value)) {
            return undefined
        }
        const key = E_CollectCardTriggerDirection[value]
        return this.$t('enum.E_CollectCardTriggerDirection.' + key)
    }
    ConstantCurrentSource = (value: E_ConstantCurrentSource) => {
        if (_.isNil(value)) {
            return undefined
        }
        const key = E_ConstantCurrentSource[value]
        return this.$t('enum.E_ConstantCurrentSource.' + key)
    }
    ChannelType = (value: E_ChannelType) => {
        if (_.isNil(value)) {
            return undefined
        }
        const key = E_ChannelType[value]
        return this.$t('enum.E_ChannelType.' + key)
    }
    CarrierReversal = (value: E_CarrierReversal) => {
        if (_.isNil(value)) {
            return undefined
        }
        const key = E_CarrierReversal[value]
        return this.$t('enum.E_CarrierReversal.' + key)
    }
    GateWayModel = (value: E_GateWayModel) => {
        if (_.isNil(value)) {
            return undefined
        }
        const key = E_GateWayModel[value]
        return this.$t('enum.E_GateWayModel.' + key)
    }
    DHCPModel = (value: E_DHCPModel) => {
        if (_.isNil(value)) {
            return undefined
        }
        const key = E_DHCPModel[value]
        return this.$t('enum.E_DHCPModel.' + key)
    }
    SensorNetworkingCollType = (value: E_SensorNetworkingCollType) => {
        if (_.isNil(value)) {
            return undefined
        }
        const key = E_SensorNetworkingCollType[value]
        return this.$t('enum.E_SensorNetworkingCollType.' + key)
    }
    AlarmAttachType = (value: E_AlarmAttachType) => {
        if (_.isNil(value)) {
            return undefined
        }
        const key = E_AlarmAttachType[value]
        return this.$t('enum.E_AlarmAttachType.' + key)
    }

    PushAppMessage = (value: E_PushAppMessage) => {
        if (_.isNil(value)) {
            return undefined
        }
        const key = E_PushAppMessage[value]
        return this.$t('enum.E_PushAppMessage.' + key)
    }

    SendWaveStatus = (value: E_SendWaveStatus) => {
        if (_.isNil(value)) {
            return
        }        
        const key = E_SendWaveStatus[value]
        if(_.isNil(key)){
            return value
        }
        return this.$t('enum.E_SendWaveStatus.' + key)
    }

    FirewareUpgradeStatus = (value: E_FirewareUpgradeStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_FirewareUpgradeStatus[value]
        return this.$t('enum.E_FirewareUpgradeStatus.' + key)
    }

    FaultStatus = (value: E_FaultStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_FaultStatus[value]
        return this.$t('enum.E_FaultStatus.' + key)
    }
    YesNoNumber__OpenClose = (value: E_YesNoNumber) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_YesNoNumber[value]
        return this.$t('enum.E_YesNoNumber__OpenClose.' + key)
    }
    UseLearnStatus = (value: E_UseLearnStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_UseLearnStatus[value]
        return this.$t('enum.E_UseLearnStatus.' + key)
    }
    ConvertProtocolType = (value: E_ConvertProtocolType) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_ConvertProtocolType[value]
        return this.$t('enum.E_ConvertProtocolType.' + key)
    }
    AppCustoms = (value: E_AppCustoms) => {
        const key = E_AppCustoms[value]
        return this.$t('enum.E_AppCustoms.' + key)
    }
    PlatformCustoms = (value: E_PlatformCustoms) => {
        const key = E_PlatformCustoms[value]
        return this.$t('enum.E_PlatformCustoms.' + key)
    }
    AiDiagnosisStatus = (value: E_AiDiagnosisStatus) => {
        const key = E_AiDiagnosisStatus[value]
        return this.$t('enum.E_AiDiagnosisStatus.' + key)
    }
    AiDiagnosisStatus__2 = (value: E_AiDiagnosisStatus) => {
        const key = E_AiDiagnosisStatus[value]
        return this.$t('enum.E_AiDiagnosisStatus__2.' + key)
    }
    FirmwireDeviceType = (value: E_FirmwireDeviceType) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_FirmwireDeviceType[value]
        return this.$t('enum.E_FirmwireDeviceType.' + key)
    }
    GatewayUpgradeStatus = (value: E_GatewayUpgradeStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_GatewayUpgradeStatus[value]
        return this.$t('enum.E_GatewayUpgradeStatus.' + key)
    }
    UnbindSensorStatus = (value: E_UnbindSensorStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_UnbindSensorStatus[value]
        return this.$t('enum.E_UnbindSensorStatus.' + key)
    }

    DiagnosticResults = (value: E_DiagnosticResults) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_DiagnosticResults[value]
        return this.$t('enum.E_DiagnosticResults.' + key)
    }
    FaultType = (value: E_FaultType) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_FaultType[value]
        return this.$t('enum.E_FaultType.' + key)
    }
    Lang = (value: E_Lang) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_Lang[value]
        return this.$t('enum.E_Lang.' + key)
    }
    EquipmentType = (value: E_EquipmentType) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_EquipmentType[value]
        return this.$t('enum.E_EquipmentType.' + key)
    }
    MenuItem = (value: E_MenuItem) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_MenuItem[value]
        return this.$t('enum.E_MenuItem.' + key)
    }
    WirelessFrequency = (value: E_WirelessFrequency) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_WirelessFrequency[value]
        return this.$t('enum.E_WirelessFrequency.' + key)
    }
    CardStatus = (value: E_CardStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_CardStatus[value]
        return this.$t('enum.E_CardStatus.' + key)
    }
    RegisterStatus = (value: E_RegisterStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_RegisterStatus[value]
        return this.$t('enum.E_RegisterStatus.' + key)
    }
    WifiStatus = (value: E_WifiStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_WifiStatus[value]
        return this.$t('enum.E_WifiStatus.' + key)
    }
    ScoreLevelRange__Detail = (value: E_ScoreLevelRange) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_ScoreLevelRange[value]
        return this.$t('enum.E_ScoreLevelRange__Detail.' + key)
    }
    ScoreAlarmStatus = (value: E_ScoreAlarmStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_ScoreAlarmStatus[value]
        return this.$t('enum.E_ScoreAlarmStatus.' + key)
    }
    ScoreStatus = (value: E_ScoreStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_ScoreStatus[value]
        return this.$t('enum.E_ScoreStatus.' + key)
    }
    FaultCaseLibraryIsPublic = (value: E_FaultCaseLibraryIsPublic) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_FaultCaseLibraryIsPublic[value]
        return this.$t('enum.E_FaultCaseLibraryIsPublic.' + key)
    }
    KnownRoles = (value: E_KnownRoles) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_KnownRoles[value]
        return this.$t('enum.E_KnownRoles.' + key)
    }
    EquipmentRunStatus = (value: E_EquipmentRunStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_EquipmentRunStatus[value]
        return this.$t('enum.E_EquipmentRunStatus.' + key)
    }
    WeekReportDealStatus = (value: E_WeekReportDealStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_WeekReportDealStatus[value]
        return this.$t('enum.E_WeekReportDealStatus.' + key)
    }
    CoefType = (value: E_CoefType) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_CoefType[value]
        return this.$t('enum.E_CoefType.' + key)
    }
    SensorDownloadStatus = (value: E_SensorDownloadStatus) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_SensorDownloadStatus[value]
        return this.$t('enum.E_SensorDownloadStatus.' + key)
    }
    EquipmentOrderBy = (value: E_EquipmentOrderBy) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_EquipmentOrderBy[value]
        return this.$t('enum.E_EquipmentOrderBy.' + key)
    }
    MapType = (value: E_MapType) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_MapType[value]
        return this.$t('enum.E_MapType.' + key)
    }
    MapType_2 = (value: E_MapType) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_MapType[value]
        return this.$t('enum.E_MapType_2.' + key)
    }
    MapTypeStr = (value: E_MapTypeStr) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_MapType[value]
        return this.$t('enum.E_MapType.' + key)
    }
    ModelFaultType = (value: E_ModelFaultType) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_ModelFaultType_Invert[value]
        return this.$t('enum.E_ModelFaultType.' + key)
    }
    ModelFaultTypeKind = (value: E_ModelFaultTypeKind) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_ModelFaultTypeKind[value]
        return this.$t('enum.E_ModelFaultTypeKind.' + key)
    }
    SensorPushStatus = (value: E_SensorPushStatus) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_SensorPushStatus[value]
        return this.$t('enum.E_SensorPushStatus.' + key)
    }
    GatewayOnLineStatus = (value: E_GatewayOnLineStatus) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_GatewayOnLineStatus[value]
        return this.$t('enum.E_GatewayOnLineStatus.' + key)
    }

    GatewayTranslateProtocol = (value: E_GatewayTranslateProtocol) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_GatewayTranslateProtocol[value]
        return this.$t('enum.E_GatewayTranslateProtocol.' + key)
    }
    GatewayDataFormat = (value: E_GatewayDataFormat) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_GatewayDataFormat[value]
        return this.$t('enum.E_GatewayDataFormat.' + key)
    }
    GatewayDHCPModel = (value: E_GatewayDHCPModel) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_GatewayDHCPModel[value]
        return this.$t('enum.E_GatewayDHCPModel.' + key)
    }
    LoraLowSpeedOpt = (value: E_LoraLowSpeedOpt) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_LoraLowSpeedOpt[value]
        return this.$t('enum.E_LoraLowSpeedOpt.' + key)
    }
    LoraBandwidth = (value: E_LoraBandwidth) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_LoraBandwidthInverse[value]
        return this.$t('enum.E_LoraBandwidth.' + key)
    }
    SimStatus = (value: E_SimStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_SimStatus[value]
        return this.$t('enum.E_SimStatus.' + key)
    }
    SyncCollectStatus = (value: E_SyncCollectStatus) => {
        if (_.isNil(value)) {
            return
        }
        const key = E_SyncCollectStatus[value]
        return this.$t('enum.E_SyncCollectStatus.' + key)
    }
    SensorCurrentLegend = (value: E_SensorCurrentLegend) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_SensorCurrentLegend[value]
        return this.$t('enum.E_SensorCurrentLegend.' + key)
    }
    SensorKlass = (value: E_SensorKlass) => {
        if (_.isNil(value)) {
            return
        }
        if (!hasSensorKlassTrans(value)) {
            return value
        }
        let key = E_SensorKlass[value]
        return this.$t('enum.E_SensorKlass.' + key)
    }

    SensorRegisterStatus = (value: E_SensorRegisterStatus) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_SensorRegisterStatus[value]
        return this.$t('enum.E_SensorRegisterStatus.' + key)
    }
    OfflineDataStatus = (value: E_OfflineDataStatus) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_OfflineDataStatus[value]
        return this.$t('enum.E_OfflineDataStatus.' + key)
    }
    WifiConnectStatus = (value: E_WifiConnectStatus) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_WifiConnectStatus[value]
        return this.$t('enum.E_WifiConnectStatus.' + key)
    }
    SimOnlineStatus = (value: E_SimOnlineStatus) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_SimOnlineStatus[value]
        return this.$t('enum.E_SimOnlineStatus.' + key)
    }
    SimNetworkRegisterStatus = (value: E_SimNetworkRegisterStatus) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_SimNetworkRegisterStatus[value]
        return this.$t('enum.E_SimNetworkRegisterStatus.' + key)
    }
    OrderByColumn = (value: E_OrderByColumn) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_OrderByColumn[value]
        return this.$t('enum.E_OrderByColumn.' + key)
    }
    AlarmStatus = (value: E_AlarmStatus) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_AlarmStatus[value]
        return this.$t('enum.E_AlarmStatus.' + key)
    }
    TaskCycleType = (value: E_TaskCycleType) => {
        if(_.isNil(value)) {
            return
        }
        let key = E_TaskCycleType[value]
        return this.$t('enum.E_TaskCycleType.' + key)
    }
    RepeatFlag = (value: E_RepeatFlag) => {
        if(_.isNil(value)) {
            return
        }
        let key = E_RepeatFlag[value]
        return this.$t('enum.E_RepeatFlag.' + key)
    }
    IsInspect = (value: E_IsInspect) => {
        if(_.isNil(value)) {
            return
        }
        let key = E_IsInspect[value]
        return this.$t('enum.E_IsInspect.' + key)
    }
    Weekdays = (value: E_Weekdays) => {
        if(_.isNil(value)) {
            return
        }
        let key = E_Weekdays[value]
        return this.$t('enum.E_Weekdays.' + key)
    }
    FaultTagGraphCategory = (value: E_FaultTagGraphCategory) => {
        if(_.isNil(value)) {
            return
        }        
        return this.$t('enum.E_FaultTagGraphCategory.' + value)
    }
    FaultTagType = (value: E_FaultTagType) => {
        if(_.isNil(value)) {
            return
        }
        let key = E_FaultTagType[value]
        return this.$t('enum.E_FaultTagType.' + key)
    }
    EigenvalueKind = (value: E_EigenvalueKind)  => {
        if(_.isNil(value)) {
            return
        }
        let key = E_EigenvalueKind[value]
        return this.$t('enum.E_EigenvalueKind.' + key)
    }
    RssiLevel = (value: E_RssiLevel) => {
        if (_.isNil(value)) {
            return
        }
        let key = E_RssiLevel[value]
        return this.$t('enum.E_RssiLevel.' + key)
    }
    DataSamplingMode = (value: E_DataSamplingMode) => {
        if(_.isNil(value)) {
            return
        }
        let key = E_DataSamplingMode[value]
        return this.$t('enum.E_DataSamplingMode.' + key)
    }
    WaveCompressFlag = (value: E_WaveCompressFlag) => {
        if(_.isNil(value)) {
            return
        }
        let key = E_WaveCompressFlag[value]
        return this.$t('enum.E_WaveCompressFlag.' + key)
    }
    CommunicationProtocolType = (value: E_CommunicationProtocolType) => {
        if(_.isNil(value)) {
            return
        }
        let key = E_CommunicationProtocolType[value]
        return this.$t('enum.E_CommunicationProtocolType.' + key)
    }
    OpenClose1_2 = (value: E_OpenClose1_2) => {
        if(_.isNil(value)) {
            return
        }
        let key = E_OpenClose1_2[value]
        return this.$t('enum.E_OpenClose1_2.' + key)
    }
    ProtocolVersion = (value: E_ProtocolVersion) => {
        if(_.isNil(value)) {
            return
        }
        let key = E_ProtocolVersion[value]
        return this.$t('enum.E_ProtocolVersion.' + key)
    }
}
